import React, { PureComponent } from 'react';
import Outter from './outter'
import message02 from 'images/soldier/message2.png';
import Request from "../../networkReq/request";
import { Link } from "react-router-dom";
import { Card, Pagination } from 'element-react';
import NoDataPicture from 'components/NoDataPicture'
import PagingContent from 'components/PagingContent'
import "./index.css";



export default class MostBeautiful extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
          navNum: '',
          params:{
            type:2,
            size:12
          }
        };
      }
   
    renderList(data) {
        if(data==''||!data.records){
          return '';
        }
        let records = data.records;
        return (
          <div className="clear" style={{ minHeight: '500px' }}>
          {
              records.length != 0 ? data.records.map(childItem => {
                  return (
                      <Card key={childItem.id}>
                          <Link to={'/entrance/soldierDetail?' + `${childItem.id}`}>
                              {
                                  childItem.image == '' ? <NoDataPicture /> :
                                  <img src={childItem.image} />
                              }
                          </Link>
                          <div className="card_title">{childItem.title}</div>
                      </Card>
                  )
              }) 
              : ''
          }
          </div>
        )
    }
      
    
  render() { 
        return (
            <div className="clear">
               <div className="outter clear">
                  <PagingContent  pageSizes={[12, 16, 20,24,28,32]}  requestUrl={Request.soldier()} renderList={this.renderList} params={this.state.params}/>
                </div>
            </div>
        )
  }
}